import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';

const routes: Routes = [
  /*{
    path: '',
    redirectTo: '',
    pathMatch: 'full'
  },
  */

  {
    path: '', 
  loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)
  },
 
  {
    path: 'p',
    loadChildren: () => import('./au/au.module').then( m => m.AuPageModule)
  },
  {
    path: 'au',
    loadChildren: () => import('./en/en.module').then( m => m.EnPageModule)
  },
  
  {
    path: 'nz',
    loadChildren: () => import('./nz/nz.module').then( m => m.NzPageModule)
  },
  {
    path: 'ca',
    loadChildren: () => import('./na/na.module').then( m => m.NaPageModule)
  },
  {
    path: 'sa',
    loadChildren: () => import('./chile/chile.module').then( m => m.ChilePageModule)
  },
  {
    path: 'uk',
    loadChildren: () => import('./uk/uk.module').then( m => m.UkPageModule)
  },
  // {
  //   path: 'af',
  //   loadChildren: () => import('./af/af.module').then( m => m.AfPageModule)
  // },
  // {
  //   path: 'jp',
  //   loadChildren: () => import('./jp/jp.module').then( m => m.JpPageModule)
  // },
  {
    path: 'p/:index',
    loadChildren: () => import('./aupagedetail/aupagedetail.module').then( m => m.AupagedetailPageModule)
  },
  {
    path: 'locations',
    loadChildren: () => import('./locations/locations.module').then( m => m.LocationsPageModule)
  },
  {
    path: ':ct/locations',
    loadChildren: () => import('./location-list/location-list.module').then( m => m.LocationListPageModule)
  },
  {
    path: ':ct/locations/:index',
    loadChildren: () => import('./location-detail/location-detail.module').then( m => m.LocationDetailPageModule)
  },
  {
    path: 'contact-us',
    loadChildren: () => import('./contact/contact.module').then( m => m.ContactPageModule)
  },
  {
    path: 'menu',
    loadChildren: () => import('./menu/menu.module').then( m => m.MenuPageModule)
  },
  {
    path: 'trip-ideas',
    loadChildren: () => import('./trips/trips.module').then( m => m.TripsPageModule)
  },
  {
    path: 'trip-ideas/:index',
    loadChildren: () => import('./tripdetail/tripdetail.module').then( m => m.TripdetailPageModule)
  },
  {
    path: 'specials',
    loadChildren: () => import('./specials/specials.module').then( m => m.SpecialsPageModule)
  },
  {
    path: 'specials/:index',
    loadChildren: () => import('./detailspecials/detailspecials.module').then( m => m.DetailspecialsPageModule)
  },
  {
    path: 'menu/:index',
    loadChildren: () => import('./buy/buy.module').then( m => m.BuyPageModule)
  },
  {
    path: 'blog',
    loadChildren: () => import('./blog/blog.module').then( m => m.BlogPageModule)
  },
  {
    path: 'blog/:index',
    loadChildren: () => import('./blogdetail/blogdetail.module').then( m => m.BlogdetailPageModule)
  },
  {
    path: 'mybooking',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'relocations',
    loadChildren: () => import('./relocations/relocations.module').then( m => m.RelocationsPageModule)
  },
  {
    path: 'modal-popup',
    loadChildren: () => import('./modal-popup/modal-popup.module').then( m => m.ModalPopupPageModule)
  },
  {
    path: 'promo',
    loadChildren: () => import('./promo/promo.module').then( m => m.PromoPageModule)
  },
  {
    path: 'promo/:index',
    loadChildren: () => import('./detailpromo/detailpromo.module').then( m => m.DetailpromoPageModule)
  },
  {
    path: 'iframe',
    loadChildren: () => import('./iframe/iframe.module').then( m => m.IframePageModule)
  },
  {
    path: 'bookings-payment',
    loadChildren: () => import('./bookings-payment/bookings-payment.module').then( m => m.BookingsPaymentPageModule)
  },
  {
    path: 'bookings-select-vehicles',
    loadChildren: () => import('./bookings-select-vehicles/bookings-select-vehicles.module').then( m => m.BookingsSelectVehiclesPageModule)
  },
  {
    path: 'bookings-select-extras',
    loadChildren: () => import('./bookings-select-extras/bookings-select-extras.module').then( m => m.BookingsSelectExtrasPageModule)
  },
  {
    path: 'bookings-confirmation',
    loadChildren: () => import('./bookings-confirmation/bookings-confirmation.module').then( m => m.BookingsConfirmationPageModule)
  },
  {
    path: 'bookings-payment-af',
    loadChildren: () => import('./bookings-payment-af/bookings-payment-af.module').then( m => m.BookingsPaymentAfPageModule)
  },
  // {
  //   path: 'bookings-payment-jp',
  //   loadChildren: () => import('./bookings-payment-jp/bookings-payment-jp.module').then( m => m.BookingsPaymentJpPageModule)
  // },
  
  {
    path: 'our-depot',
    loadChildren: () => import('./maps-test/maps-test.module').then( m => m.MapsTestPageModule)
  },
  {
    path: 'campervan',
    loadChildren: () => import('./vehicles/vehicles.module').then( m => m.VehiclesPageModule)
  },
  {
    path: ':ct/campervan',
    loadChildren: () => import('./vehicles-list/vehicles-list.module').then( m => m.VehiclesListPageModule)
  },
  {
    path: ':ct/campervan/:index',
    loadChildren: () => import('./vehicles-detail/vehicles-detail.module').then( m => m.VehiclesDetailPageModule)
  },
  {
    path: 'maps-search',
    loadChildren: () => import('./maps-search/maps-search.module').then( m => m.MapsSearchPageModule)
  },
    // {
  //   path: 'nz/locations',
  //   loadChildren: () => import('./nzlocations/nzlocations.module').then( m => m.NzlocationsPageModule)
  // },
  // {
  //   path: 'nz/locations/:index',
    
  //   loadChildren: () => import('./detaillocations/detaillocations.module').then( m => m.DetaillocationsPageModule)
  // },
  // {
  //   path: 'ca/locations',
  //   loadChildren: () => import('./calocations/calocations.module').then( m => m.CalocationsPageModule)
  // },
  // {
  //   path: 'ca/locations/:index',
    
  //   loadChildren: () => import('./detaillocations/detaillocations.module').then( m => m.DetaillocationsPageModule)
  // },
  // {
  //   path: 'sa/locations',
  //   loadChildren: () => import('./calocations/calocations.module').then( m => m.CalocationsPageModule)
  // },
  // {
  //   path: 'sa/locations/:index',
    
  //   loadChildren: () => import('./detaillocations/detaillocations.module').then( m => m.DetaillocationsPageModule)
  // },
  // {
  //   path: 'uk/locations',
  //   loadChildren: () => import('./calocations/calocations.module').then( m => m.CalocationsPageModule)
  // },
  // {
  //   path: 'uk/locations/:index',
  //   loadChildren: () => import('./detaillocations/detaillocations.module').then( m => m.DetaillocationsPageModule)
  // },
  // {
  //   path: 'af/locations',
  //   loadChildren: () => import('./calocations/calocations.module').then( m => m.CalocationsPageModule)
  // },
  // {
  //   path: 'af/locations/:index',
  //   loadChildren: () => import('./detaillocations/detaillocations.module').then( m => m.DetaillocationsPageModule)
  // },
  /*
  {
    path: 'locations/:index',
    loadChildren: () => import('./detaillocations/detaillocations.module').then( m => m.DetaillocationsPageModule)
  },
  */
  /*{
    path: 'checkin-select-extras',
    loadChildren: () => import('./checkin-select-extras/checkin-select-extras.module').then( m => m.CheckinSelectExtrasPageModule)
  },
  {
    path: 'checkin-driver',
    loadChildren: () => import('./checkin-driver/checkin-driver.module').then( m => m.CheckinDriverPageModule)
  },
  {
    path: 'checkin-document',
    loadChildren: () => import('./checkin-document/checkin-document.module').then( m => m.CheckinDocumentPageModule)
  },
  {
    path: 'checkin-payment',
    loadChildren: () => import('./checkin-payment/checkin-payment.module').then( m => m.CheckinPaymentPageModule)
  },
  {
    path: 'checkin-payment-nz',
    loadChildren: () => import('./checkin-payment-nz/checkin-payment-nz.module').then( m => m.CheckinPaymentNzPageModule)
  },
  {
    path: 'checkin-payment-ca',
    loadChildren: () => import('./checkin-payment-ca/checkin-payment-ca.module').then( m => m.CheckinPaymentCaPageModule)
  },
  {
    path: 'checkin-payment-uk',
    loadChildren: () => import('./checkin-payment-uk/checkin-payment-uk.module').then( m => m.CheckinPaymentUkPageModule)
  },
  {
    path: 'online-checkin',
    loadChildren: () => import('./online-checkin/online-checkin.module').then( m => m.OnlineCheckinPageModule)
  },*/
    // {
  //   path: 'nz-bookings-select-vehicles',
  //   loadChildren: () => import('./nz-bookings-select-vehicles/nz-bookings-select-vehicles.module').then( m => m.NzBookingsSelectVehiclesPageModule)
  // },
  // {
  //   path: 'nz-bookings-select-extras',
  //   loadChildren: () => import('./nz-bookings-select-extras/nz-bookings-select-extras.module').then( m => m.NzBookingsSelectExtrasPageModule)
  // },
  // {
  //   path: 'nz-bookings-payment',
  //   loadChildren: () => import('./nz-bookings-payment/nz-bookings-payment.module').then( m => m.NzBookingsPaymentPageModule)
  // },
  // {
  //   path: 'nz-bookings-confirmation',
  //   loadChildren: () => import('./nz-bookings-confirmation/nz-bookings-confirmation.module').then( m => m.NzBookingsConfirmationPageModule)
  // },
    // {
  //   path: 'au/our-vehicles', 
  //   loadChildren: () => import('./our-vehicles/our-vehicles.module').then( m => m.OurVehiclesPageModule)
  // },
  // {
  //   path: 'au/campervan/campervan-hire',
  //   loadChildren: () => import('./campervan/campervan.module').then( m => m.CampervanPageModule)
  // },
  // {
  //   path: 'au/our-vehicles/campervan-hire/:index',
  //   loadChildren: () => import('./details/details.module').then( m => m.DetailsPageModule)
  // },
  // {
  //   path: 'au/campervan/:index',
  //   loadChildren: () => import('./details/details.module').then( m => m.DetailsPageModule)
  // },
  // {
  //   path: 'au/our-vehicles/car-hire',
  //   loadChildren: () => import('./carhire/carhire.module').then( m => m.CarhirePageModule)
  // },
  // {
  //   path: 'au/our-vehicles/car-hire/:index',
  //   loadChildren: () => import('./details/details.module').then( m => m.DetailsPageModule)
  // },
  // {
  //   path: 'au/our-vehicles/4wd-rental',
  //   loadChildren: () => import('./awd/awd.module').then( m => m.AwdPageModule)
  // },
  // {
  //   path: 'au/our-vehicles/4wd-rental/:index',
  //   loadChildren: () => import('./details/details.module').then( m => m.DetailsPageModule)
  // },
  // {
  //   path: 'nz/campervan',
  //   loadChildren: () => import('./nzvehicles/nzvehicles.module').then( m => m.NzvehiclesPageModule)
  // },
  // {
  //   path: 'nz/our-vehicles/campervan-hire',
  //   loadChildren: () => import('./campervan/campervan.module').then( m => m.CampervanPageModule)
  // },
  // {
  //   path: 'nz/campervan/:index',
  //   loadChildren: () => import('./details/details.module').then( m => m.DetailsPageModule)
  // },
  // {
  //   path: 'ca/campervan',
  //   loadChildren: () => import('./navehicles/navehicles.module').then( m => m.NavehiclesPageModule)
  // },

  // {
  //   path: 'ca/campervan/:index',
  //   loadChildren: () => import('./details/details.module').then( m => m.DetailsPageModule)
  // },
  // {
  //   path: 'sa/campervan',
  //   loadChildren: () => import('./clvehicles/clvehicles.module').then( m => m.ClvehiclesPageModule)
  // },
  // {
  //   path: 'sa/campervan/:index',
  //   loadChildren: () => import('./details/details.module').then( m => m.DetailsPageModule)
  // },
  // {
  //   path: 'uk/campervan',
  //   loadChildren: () => import('./ukvehicles/ukvehicles.module').then( m => m.UkvehiclesPageModule)
  // },
  // {
  //   path: 'uk/campervan/:index',
  //   loadChildren: () => import('./details/details.module').then( m => m.DetailsPageModule)
  // },
  // {
  //   path: 'af/campervan/:index',
  //   loadChildren: () => import('./details/details.module').then( m => m.DetailsPageModule)
  // },
 

  // {
  //   path: 'location-list',
  //   loadChildren: () => import('./location-list/location-list.module').then( m => m.LocationListPageModule)
  // },
  // {
  //   path: 'location-detail',
  //   loadChildren: () => import('./location-detail/location-detail.module').then( m => m.LocationDetailPageModule)
  // },
//{ path: 'tabs/home/:index', loadChildren: './details/details.module#DetailsPageModule' },
  { path: '**', component: PagenotfoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, initialNavigation: 'enabled' }),
    RouterModule.forRoot(routes)



  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
